<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">View Codes</h3>

          <button type="button" class="btn btn-secondary mt-2" @click="$router.go(-1)">
            &lt; Back
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Info Section -->
    <div class="section" v-if="isAuthorized">
      <div class="row">
        <div class="col-md-6">
          <label class="mb-0">Merchant Name</label><br />
          <h4>{{ merchant }}</h4>
        </div>
        <div class="col-md-6">
          <label class="mb-0">Uploaded Datetime</label><br />
          <h4>{{ uploadedDate }}</h4>
        </div>
      </div>
    </div>
    <!-- /Info Section -->

    <!-- Code List -->
    <div class="section mt-4" v-if="isAuthorized">
      <!-- Filter -->
      <div class="row align-items-center">
        <div class="col">
          <div class="row align-items-center">
            <div class="col-md-1 pr-0 fit-content">
              <label class="mb-0">Status</label>
            </div>
            <div class="col-md-3 fit-content">
              <select
                class="form-control"
                v-model="status"
                @change="getBatchEcouponDetails"
              >
                <!--<option value="">All</option>-->
                <option :value="ecouponStatusActive">
                  {{ ecouponStatusActive }} ({{ totalCodes.active }})
                </option>
                <option :value="ecouponStatusIssued">
                  {{ ecouponStatusIssued }} ({{ totalCodes.issued }})
                </option>
                <option :value="ecouponStatusRedeemed">
                  {{ ecouponStatusRedeemed }} ({{ totalCodes.redeemed }})
                </option>
                <option :value="ecouponStatusCancelled">
                  {{ ecouponStatusCancelled }} ({{ totalCodes.cancelled }})
                </option>
                <option :value="ecouponStatusVoided">
                  {{ ecouponStatusVoided }} ({{ totalCodes.voided }})
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-auto float-right ml-auto" v-if="status == ecouponStatusActive">
          <button type="submit" class="btn btn-primary mr-2" form="codeForm">
            Update
          </button>
          <button type="button" class="btn btn-danger" @click="window.location.href = window.location.href">
            Cancel
          </button>
        </div>
      </div>
      <!-- /Filter -->

      <!-- Table List -->
      <form id="codeForm" @submit.prevent="save">
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
              <table class="table table-bordered custom-table mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="min-width: 250px; width: 300px;">Code</th>
                    <th v-if="hasIssueCodes" style="width: 200px">Issued Datetime</th>
                    <th v-if="status == ecouponStatusRedeemed || status == ecouponStatusCancelled || status == ecouponStatusVoided" style="width: 200px">Redeemed Datetime</th>
                    <th v-if="status == ecouponStatusCancelled" style="width: 200px">Cancelled Datetime</th>
                    <th v-if="status == ecouponStatusVoided" style="width: 200px">Voided Datetime</th>
                    <th>Additional Info</th>
                    <th style="width: 70px" v-if="status == ecouponStatusActive">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addCode"
                      >
                        <i class="fa fa-plus" title="Add Code"></i>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in newCodes" :key="i">
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.code"
                        maxlength="50"
                        required
                      />
                    </td>
                    <td v-if="hasIssueCodes"></td>
                    <td></td>
                    <td>
                      <textarea
                        class="form-control"
                        disabled
                        v-model="item.remarks"
                      ></textarea>
                    </td>                    
                    <td>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="removeNewCode(i)"
                      >
                        <i class="fa fa-trash-o" title="Remove Code"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-for="item in displayedCodes" :key="'code' + item.id">
                    <td>
                      <input
                        :disabled="item.status == ecouponStatusRedeemed || item.status == ecouponStatusIssued || item.status == ecouponStatusCancelled || item.status == ecouponStatusVoided"
                        type="text"
                        class="form-control"
                        v-model="item.code"
                        maxlength="50"
                        required
                      />
                    </td>
                    <td>
                      {{ item.issued_date_display != null ? item.issued_date_display : 'NA' }}
                    </td>
                    <td v-if="status && (status == ecouponStatusRedeemed || status == ecouponStatusCancelled || status == ecouponStatusVoided)">
                      {{ item.redeemed_date_display != null ? item.redeemed_date_display : 'NA' }}
                    </td>
                    <td v-if="status && status == ecouponStatusCancelled">
                      {{ item.cancelled_date_display != null ? item.cancelled_date_display : 'NA' }}
                    </td>
                    <td v-if="status && status == ecouponStatusVoided">
                      {{ item.voided_date_display != null ? item.voided_date_display : 'NA' }}
                    </td>
                    <td>
                      <span v-if="item.addon_name">Package Details: {{ item.addon_name }}<br></span>
                      <span v-if="item.booking_confirmation_no">Confirmation No: {{ item.booking_confirmation_no }}<br></span>
                      <span v-if="item.booking_id">Reservation ID: {{ item.booking_id }}<br></span>
                      <span v-if="item.booking_date">{{ merchantAddonDateLabel }}: {{ item.booking_date }}<br></span>
                      <span v-if="item.addon_price">Unit Selling Price: {{ item.addon_price }}<br></span>
                      <span style="text-wrap: auto;" v-if="item.remarks">{{ item.remarks }}</span>
                      <span style="text-wrap: auto;" v-if="item.cancellation_reason">Cancellation Reason: {{ item.cancellation_reason }}</span>
                      <span style="text-wrap: auto;" v-if="item.void_remarks">Void Remarks: {{ item.void_remarks }}</span>
                      <!--<textarea
                        class="form-control"
                        disabled
                        v-model="item.remarks"
                      ></textarea>-->
                    </td>
                    <td v-if="status == ecouponStatusActive && item.status == ecouponStatusActive">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="removeCode(item.id)"
                      >
                        <i class="fa fa-trash-o" title="Remove Code"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!codes || !codes.length">
                    <td
                      :colspan="(status == ecouponStatusCancelled || status == ecouponStatusVoided) ? 5 : 4"
                      class="text-center">
                      {{ noRecordText }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
      <!-- /Table List -->

      <!--Pagination -->
      <div class="row" v-if="codes && codes.length">
        <div
          class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
        ></div>
        <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
          <div class="navbar justify-content-end">
            <button
              v-on:click="first()"
              v-if="paging.CurrentPage != 1"
              class="btn btn-sm btn-white"
            >
              First
            </button>
            <button
              v-on:click="prev()"
              class="btn btn-sm btn-white ml-1 mr-3"
              v-if="paging.CurrentPage > 1"
            >
              Prev
            </button>
            Page
            <input
              class="form-control form-control-sm mx-1"
              type="number"
              step="1"
              min="1"
              :max="paging.TotalPage"
              v-model="paging.CurrentPage"
              @change="onCurrentPageChange($event)"
              style="width: 4rem"
            />
            <span>of {{ paging.TotalPage }}</span>
            <button
              v-on:click="next()"
              class="btn btn-sm btn-white ml-3 mr-1"
              v-if="paging.CurrentPage < paging.TotalPage"
            >
              Next
            </button>
            <button
              v-on:click="last()"
              v-if="paging.CurrentPage != paging.TotalPage"
              class="btn btn-sm btn-white"
            >
              Last
            </button>
          </div>
        </div>
      </div>
      <!--/Pagination -->

      <!-- Buttons -->
      <div class="row mt-4" v-if="status == ecouponStatusActive">
        <div class="col-md-12 text-center">
          <button type="submit" class="btn btn-primary mr-2" form="codeForm">
            Update
          </button>
          <button type="button" class="btn btn-danger" @click="window.location.href = window.location.href">
            Cancel
          </button>
        </div>
      </div>
      <!-- /Buttons -->
    </div>
    <!-- /Code List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      ecouponStatusActive: config.ECOUPON_STATUS_ACTIVE,
      ecouponStatusIssued: config.ECOUPON_STATUS_ISSUED,
      ecouponStatusRedeemed: config.ECOUPON_STATUS_REDEEMED,
      ecouponStatusDeleted: config.ECOUPON_STATUS_DELETED,
      ecouponStatusCancelled: config.ECOUPON_STATUS_CANCELLED,
      ecouponStatusVoided: config.ECOUPON_STATUS_VOIDED,
      isAuthorized: true,
      hasIssueCodes: false,
      newCodes: [],
      codes: [],
      merchant: "",
      merchantAddonDateLabel: "",
      uploadedDate: "",
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
      },
      totalRecords: "",
      //filter
      status: config.ECOUPON_STATUS_ACTIVE,
      totalCodes: {
        active: 0,
        issued: 0,
        redeemed: 0,
        cancelled: 0,
        voided: 0
      }
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    displayedCodes() {
      return this.codes.filter((c) => c.status != this.ecouponStatusDeleted);
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getBatchEcouponList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    addCode() {
      this.newCodes.unshift({
        id: "",
        code: "",
        remarks: "",
        status: this.ecouponStatusActive,
        redeemed_date: "",
        redeemed_date_display: "",
      });
    },
    removeNewCode(index) {
      this.newCodes.splice(index, 1);
    },
    removeCode(id) {
      let code = this.codes.find((c) => c.id == id);
      if (code) code.status = this.ecouponStatusDeleted;
    },
    save() {
      let param = {
        id: this.$route.params.id,
        codes: this.codes,
        new_codes: this.newCodes,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to update the codes?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveBatchEcouponDetails(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (response.data.success) {
                this.$swal(response.data.message, { icon: "success" });
                this.codes = [];
                this.newCodes = [];
                this.status = this.ecouponStatusActive;
                this.getBatchEcouponDetails();
              } else {
                if (response.data.has_duplicate) {
                  this.$swal(response.data.errors.join("\n"), {
                    icon: "error",
                  });
                } else {
                  this.$swal(response.data.message, { icon: "error" });
                }
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    getBatchEcouponDetails() {
      let param = {
        id: this.$route.params.id,
        status: this.status,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
      };
      this.$store.state.isLoading = true;
      API.getBatchEcouponDetails(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.is_authorized) {
              this.codes = response.data.records;
              this.merchant = response.data.merchant;
              this.merchantAddonDateLabel = response.data.merchant_addon_date_label;
              this.hasIssueCodes = response.data.has_issue_codes;
              this.uploadedDate = response.data.uploaded_date;
              this.totalRecords = response.data.total;
              this.paging.TotalPage = response.data.page_count;
              this.totalCodes.active = response.data.total_active_codes;
              this.totalCodes.issued = response.data.total_issued_codes;
              this.totalCodes.redeemed = response.data.total_redeemed_codes;
              this.totalCodes.cancelled = response.data.total_cancelled_codes;
              this.totalCodes.voided = response.data.total_voided_codes;
              if (this.paging.CurrentPage > this.paging.TotalPage) {
                this.paging.CurrentPage = 1;
              }
            } else {
              this.isAuthorized = false;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getBatchEcouponDetails();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getBatchEcouponDetails();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getBatchEcouponDetails();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getBatchEcouponDetails();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getBatchEcouponDetails();
    },
  },
  created() {
    this.getBatchEcouponDetails();
  },
};
</script>

<style scoped>
.table.custom-table > tbody > tr > td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
table button.btn-danger {
  width: 38.17px;
  height: 37.6px;
}
</style>


// WEBPACK FOOTER //
// src/components/Share/BatchEcouponDetail.vue